import React from 'react';
import './ServicesPage.css';

function ServicesPage() {
    return (
        <section className="services-section">
            <div className="services-header">
                <h1>Nos Services</h1>
                <p>
                    Découvrez l’ensemble des prestations que nous proposons pour répondre à vos besoins
                    en matière d’antiquités et de débarras. Notre équipe se tient à votre disposition
                    pour toute question ou demande de devis.
                </p>
            </div>

            <div className="services-content">
                {/* Rachat d'Antiquités */}
                <div className="service-card">
                    <h2>Rachat d'Antiquités</h2>
                    <p>
                        Vous possédez des meubles anciens, des objets d’art, ou tout autre trésor historique&nbsp;?
                        Nous proposons un service de <strong>rachat d'antiquités</strong> aux particuliers et
                        aux professionnels. Notre équipe d’experts se charge d’estimer la valeur de vos pièces
                        afin de vous proposer un prix juste et transparent.
                    </p>
                    <p>
                        <em>Pourquoi nous choisir&nbsp;?</em>
                        Parce que nous mettons un point d’honneur à respecter l’authenticité
                        et la provenance de chaque objet. Chaque rachat se fait dans le
                        respect de vos attentes et de la valeur historique de vos biens.
                    </p>
                </div>

                {/* Débarras */}
                <div className="service-card">
                    <h2>Service de Débarras</h2>
                    <p>
                        Notre <strong>service de débarras</strong> s’adresse aux personnes souhaitant
                        vider un local, un grenier, une succession ou toute autre propriété.
                        Qu’il s’agisse de meubles volumineux ou d’objets divers, notre équipe
                        intervient rapidement et efficacement pour vous soulager de cette tâche.
                    </p>
                    <p>
                        Le débarras est également un moment idéal pour repérer d’éventuelles
                        antiquités qui pourraient avoir de la valeur. Nous proposons, le cas
                        échéant, un rachat direct ou une estimation professionnelle.
                    </p>
                </div>

                {/* Visite Gratuite */}
                <div className="service-card">
                    <h2>Visite Gratuite & Estimation</h2>
                    <p>
                        Vous avez hérité de biens anciens ou souhaitez simplement faire estimer
                        certains objets&nbsp;? Nous proposons une <strong>visite gratuite</strong>
                        à votre domicile ou dans vos locaux pour examiner les articles, en
                        évaluer l’authenticité et vous donner une estimation précise.
                    </p>
                    <p>
                        Notre approche se veut transparente et pédagogique&nbsp;: nous
                        prenons le temps de vous expliquer les critères d’évaluation
                        (époque, état de conservation, rareté, etc.), afin de vous
                        accompagner au mieux dans la prise de décision.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default ServicesPage;
